import { FormField } from "../../../../models/form-builder/form-field.model";

export class FormFieldListConstraintColumn {
    public formFieldId: number;
    public formFieldName: string;
    public constraintId: number;
    public constraintName: string;
    public listConstraintColumnId: number;
    public listConstraintColumnName: string;
    public columnName: string;

    public constructor(formFieldId: number, columnId: number) {
        this.formFieldId = formFieldId;
        this.listConstraintColumnId = columnId;
    }
}

export class FlexibleSelectionFieldConfigurationData {
    public formField: FormField;
    public formFields: FormField[];
    public formTemplateId: number;
    public listValuesConstraintName: string;
    public dependsOnParentFormFieldName: string;
    public ListConstraintColumnId: number;
    public CascadingDropdownConstraintId: number;
    public fieldColumnPairs: FormFieldListConstraintColumn[];
    public sourceFieldConstraints: FormFieldListConstraintColumn[];
}
